import { createStyles, makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) =>
  createStyles({
    middlePaper: {
      padding: theme.spacing(2),
    },
  })
);
